import User from "../Models/User";
import PageModel from "../Models/ViewModels/PageModel";
import MakeRequest from "../Utilities/MakeRequest";

export function fetchUsersList(searchValue: string, sortValue: string, sortAscending: boolean, currentPage: number, pageSize: number): Promise<PageModel<User>> {
	return new Promise<PageModel<User>>((resolve, reject) => {
		new MakeRequest(`/api/Users/search?searchValue=${searchValue}&SortValue=${sortValue}&SortAscending=${sortAscending}&Page=${currentPage}&Size=${pageSize}`)
			.send()
			.then((response: string) => {
				resolve(JSON.parse(response));
			}, reject);
	});
}

export function getUser(userId: string): Promise<User> {
	return new Promise<User>((resolve, reject) => {
		new MakeRequest(`/api/users/Get?id=${userId}`)
			.send()
			.then((response: string) => {
				resolve(JSON.parse(response));
			}, reject);
	});
}

export function fetchCreateUserModal(): Promise<string> {
	return new Promise<string>((resolve, reject) => {
		new MakeRequest('/Users/create')
			.send()
			.then(resolve, reject);
	});
}

export function createUser(user: User): Promise<void> {
	return new Promise<void>((resolve, reject) => {
		const headers = {};
		headers["Content-type"] = "application/json";
		new MakeRequest('/api/Users/Create', "Post", headers)
			.send(JSON.stringify(user))
			.then(resolve, reject);
	});
}

export function fetchUpdateUserModal(userId: string): Promise<string> {
	return new Promise<string>((resolve, reject) => {
		new MakeRequest(`/Users/update?id=${userId}`)
			.send()
			.then(resolve, reject);
	});
}

export function updateUser(user: User): Promise<void> {
	return new Promise<void>((resolve, reject) => {
		const headers = {};
		headers["Content-type"] = "application/json";
		new MakeRequest('/api/Users/Update', "Put", headers)
			.send(JSON.stringify(user))
			.then(resolve, reject);
	});
}

export function fetchDeleteUserModal(userId: string): Promise<string> {
	return new Promise<string>((resolve, reject) => {
		new MakeRequest(`/Users/delete?id=${userId}`)
			.send()
			.then(resolve, reject);
	});
}

export function deleteUser(userId: string): Promise<void> {
	return new Promise<void>((resolve, reject) => {
		const headers = {};
		headers["Content-type"] = "application/json";
		new MakeRequest(`/api/Users/Delete?id=${userId}`, "delete", headers)
			.send()
			.then(resolve, reject);
	});
}

export function sendUserInvitation(userId: string): Promise<void> {
	return new Promise<void>((resolve, reject) => {
		new MakeRequest(`/api/Users/sendInvitation?id=${userId}`)
			.send()
			.then(resolve, reject);
	});
}

export function getUsersNames(ids: string[]): Promise<Map<string, string>> {
	return new Promise<Map<string, string>>((resolve, reject) => {
		new MakeRequest(`/api/Users/GetNames?userIds=${ids.join('&userIds=')}`)
			.send()
			.then((response: string) => {
				const parsed = JSON.parse(response);
				resolve(new Map(Object.entries(parsed)));
			}, reject);
	});
}
